import ConfirmationDot from '@/components/ui/verification/confirmation-dot.tsx';
import { formatAddress } from '@/lib/utils.ts';
import {
  type Address,
  ConfirmationField,
  ConfirmationTargetType,
  type Customer,
  type Deal,
} from '@/models/types';
import { observable } from 'mobx';
import { useEffect, useRef, useState } from 'react';
import AddressForm from '../../ui/address-form/address-form';
import CoRegistrantEmailEditor from './co-registrant-email-editor';
import CoRegistrantNameEditor from './co-registrant-name-editor';
import CoRegistrantPhoneEditor from './co-registrant-phone-editor';

const CoRegistrantForm = ({
  focusOnMount = false,
  coRegistrant,
  dealId,
  address,
}: {
  focusOnMount?: boolean;
  coRegistrant: Customer;
  address: Address;
  dealId: Deal['id'];
}) => {
  const firstNameRef = useRef<HTMLInputElement>(null);
  const [hasFocusedOnMount, setHasFocusedOnMount] = useState(false);

  useEffect(() => {
    if (firstNameRef.current && focusOnMount && !hasFocusedOnMount) {
      firstNameRef.current.focus();
      setHasFocusedOnMount(true);
    }
  }, [firstNameRef.current, focusOnMount, hasFocusedOnMount]);

  return (
    <div className="flex flex-col gap-1">
      <CoRegistrantNameEditor />

      <CoRegistrantEmailEditor />
      <CoRegistrantPhoneEditor />
      <div className="flex flex-col gap-0">
        <div className="flex flex-row justify-between">
          <h5 className="scroll-m-20 text-lg  tracking-tight">
            Registration Address
          </h5>
          <ConfirmationDot
            targetId={dealId}
            targetType={ConfirmationTargetType.Deal}
            field={ConfirmationField.CoRegistrantRegistrationAddress}
            value={observable.box(formatAddress(address))}
          />
        </div>
        <AddressForm
          // DEV NOTE: the address values can change without the reference changing
          // but we need the component to re-render
          key={JSON.stringify(address)}
          address={address}
          focusOnMount={false}
          dealId={dealId}
          customerIdOrCoregistrantId={coRegistrant.id}
          customerType={coRegistrant.customer_type}
        />
      </div>
    </div>
  );
};

export default CoRegistrantForm;
